import { type InputHTMLAttributes } from 'react';

import { assertNumber } from '@pkg/utils';

interface ProgressOptions {
    min?: number;
    max?: number;
    round?: boolean;
}

export type HtmlInputRangeValue = InputHTMLAttributes<HTMLInputElement>['value'];

export function calcInputRangeProgress(value = 0, { min = 0, max = 100, round = false }: ProgressOptions) {
    const range = max - min;
    const adjustedValue = value - min;
    const percentage = (adjustedValue / range) * 100;

    return round ? Math.floor(percentage) : percentage;
}

export function normalizeInputRangeValue(value?: HtmlInputRangeValue, fallback = 0) {
    if (assertNumber(value)) return value;

    if (typeof value === 'string') {
        const parsed = parseFloat(value);
        return assertNumber(parsed) ? parsed : fallback;
    }

    // We send back the `value` only if it is either a `number` or a
    // successfully parsed `string`. All other conditions return `fallback`.
    return fallback;
}
